import angular from 'angular';

export default angular.module('shared').constant('licenseLevelConstants', {
    user: {
        name: 'User',
        value: 1
    },
    device: {
        name: 'Device',
        value: 2
    }
});



// WEBPACK FOOTER //
// ./modules/shared/constants/licenseLevel.constant.js